export default "__VITE_ASSET__BN0P_QFJ__"